import { ComparisonSpec } from './ComparisonSpec';

export interface StaticComparisonSpec extends ComparisonSpec {
  readonly type: 'STATIC_COMPARISON';
  readonly value: number;
}

/**
 * @param message The user facing string to describe this spec. Unused outside
 * the adjust and compare screen in phoenix.
 * @param value The value to compare against
 * @returns
 */
export const makeStaticComparisonSpec = (message: string, value: number): StaticComparisonSpec => {
  return {
    type: 'STATIC_COMPARISON',
    value,
    message,
  };
};
